export class ResizeDebounceController
{
    /**
     * Навешиваем слушатель на ресайз окна
     * @param debouceDelay - минимальная задержка между событиями ресайза в миллисекундах
     */
    static start(debouceDelay: number = 1000, resizeFunc: Function): void {
        const debounce = (func: () => void, delay: number) => {
            let inDebounce: number;
            return function () {
                window.clearTimeout(inDebounce);
                inDebounce = window.setTimeout(func, delay);
            };
        };
        if (debouceDelay == 0) {
            window.addEventListener('resize', () => {
                //MessageHelper.sendMessage('getGameField', {});
                resizeFunc();
            }, false);
        } else {
            window.addEventListener('resize', debounce(() => {
                //MessageHelper.sendMessage('getGameField', {});
                resizeFunc();
            }, debouceDelay), false);
        }
    }
}
